/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Track_Import_HelpInputs */



/**
* | output |
* | --- |
* | "Optionally assign imported events to a track (A-D)." |
*
* @param {Event_Track_Import_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_track_import_help = /** @type {((inputs?: Event_Track_Import_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Track_Import_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Affectez éventuellement les événements importés à une piste (A-D).")
	if (locale === "de") return /** @type {LocalizedString} */ ("Optional können importierte Ereignisse einer Spur (A-D) zugeordnet werden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("È possibile assegnare, facoltativamente, gli eventi importati a una traccia (A-D).")
	if (locale === "ru") return /** @type {LocalizedString} */ ("При желании можно присвоить импортированные события дорожке (A-D).")
	if (locale === "es") return /** @type {LocalizedString} */ ("Opcionalmente, asigne los eventos importados a una pista (A-D).")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("（可选）将导入的事件分配到轨道（A-D）。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("インポートしたイベントをトラック（A～D）に任意で割り当てます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आप चाहें तो आयातित इवेंट्स को किसी ट्रैक (A-D) में असाइन कर सकते हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Opcionalmente, atribua eventos importados a uma faixa (A-D).")
	return /** @type {LocalizedString} */ ("Optionally assign imported events to a track (A-D).")
});